var map = {
	"./BOOST.svg": 2404,
	"./GRAB.svg": 2405,
	"./MBB.svg": 2406,
	"./TNG.svg": 2407,
	"./direpay.svg": 2408,
	"./doitnow.svg": 2409,
	"./duitnow.svg": 2410,
	"./fpay.svg": 2411,
	"./fpay2.svg": 2412,
	"./fpx.svg": 2413,
	"./online_banking.svg": 2414,
	"./rapidpays.svg": 2415,
	"./secret_pay.svg": 2416,
	"./secret_pay_offline.svg": 2417,
	"./secret_pay_pro.svg": 2418,
	"./secret_pay_pro_b.svg": 2419
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 213;